import { useMemo } from 'react';

import { CounterProps } from '../counter.model';

const useCounterOptions = ({
    options,
    activeControls,
    params,
}: Pick<CounterProps, 'options' | 'activeControls' | 'params'>) => {
    return useMemo(() => {
        const activeGroup = params?.group ?? activeControls?.groups?.initialValue;
        const groupConfig = options.groups.find(group => group.name === activeGroup) ?? options.groups[0];

        return {
            ...groupConfig,
            rowIndex: groupConfig?.rowIndex ?? 0,
        };
    }, [activeControls, options, params?.group]);
};

export { useCounterOptions };
